import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Flame } from 'lucide-react';
export function TopFlashBar() {
  const [timeLeft, setTimeLeft] = useState(29 * 60 + 47);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft(t => Math.max(0, t - 1)), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <AnimatePresence data-id="element-439">
      <motion.div initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a] text-[#f0ebe3] shadow-md border-b border-[var(--accent)]/20" data-id="element-440">
        <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent pointer-events-none" animate={{
        x: ['-100%', '200%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-441" />
        <div className="max-w-7xl mx-auto px-3 py-1 sm:py-1.5 flex items-center justify-center gap-1.5 sm:gap-4 relative z-10 text-[10px] sm:text-xs font-medium" data-id="element-442">
          <div className="flex items-center gap-1 flex-shrink-0" data-id="element-443">
            <Flame className="w-3 h-3 text-yellow-300 fill-yellow-300 flex-shrink-0" data-id="element-444" />
            <span className="uppercase tracking-wider font-bold text-yellow-200" data-id="element-445">
              <span className="hidden sm:inline" data-id="element-446">OFERTA DE LANZAMIENTO</span>
              <span className="sm:hidden" data-id="element-447">OFERTA</span>
            </span>
          </div>
          <span className="hidden sm:inline opacity-40" data-id="element-448">—</span>
          <span className="italic opacity-90 flex-shrink-0" data-id="element-449">
            <span className="hidden sm:inline" data-id="element-450">
              Acceso inmediato por solo $6.36 (Precio regular $27.00). Solo las
              próximas 48 horas.
            </span>
            <span className="sm:hidden" data-id="element-451">$14.36 (Reg. $27) · 48h</span>
          </span>
          <div className="flex items-center gap-0.5 font-mono font-bold bg-black/30 px-1.5 py-0.5 rounded text-yellow-200 flex-shrink-0" data-id="element-452">
            <span data-id="element-453">{pad(minutes)}</span>
            <span className="animate-pulse" data-id="element-454">:</span>
            <span data-id="element-455">{pad(seconds)}</span>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>;
}